import { PickupParticipantListPage } from "components/shared/pickupParticipants";

export const PickupAttractionParticipantList: React.FC = () => (
  <PickupParticipantListPage kind="attraction" variant="admin" />
);
